export const formatNumber = (num: number) => {
    if (Math.abs(num) >= 9_999) {
        return num.toLocaleString('en-US', {
            notation: 'compact',
            compactDisplay: 'short',
            maximumFractionDigits: 1
        });
    }

    return num.toLocaleString('en-US');
};

export const formatPercentNumber = (num: number) => {
    if (Math.abs(num) >= 999) {
        return num.toLocaleString('en-US', {
            notation: 'compact',
            compactDisplay: 'short',
            maximumFractionDigits: 1
        });
    }

    return num.toLocaleString('en-US');
};